import type { Nutrients } from './nutrients.ts';
import type { Unit } from './units.ts';

/** Store sections a shopping list is grouped by (PLAN.md §4). */
export const STORE_CATEGORIES = [
  'produce',
  'bakery',
  'dairy',
  'meat',
  'fish',
  'dry_goods',
  'spices',
  'frozen',
  'drinks',
  'other',
] as const;
export type StoreCategory = (typeof STORE_CATEGORIES)[number];

export const INGREDIENT_SOURCES = ['seed', 'llm', 'user'] as const;
export type IngredientSource = (typeof INGREDIENT_SOURCES)[number];

/** Weight in grams of one of a count or volume unit for this ingredient ("1 Zwiebel" = 110 g). */
export type UnitGrams = Partial<Record<Unit, number>>;

export interface PackSize {
  qty: number;
  unit: Unit;
}

/** Catalog facts the calculators need (a subset of the `ingredient` row). */
export interface CatalogFacts {
  id: string;
  nutrients: Nutrients | null;
  unitGrams: UnitGrams;
  densityGPerMl: number | null;
  packSize: PackSize | null;
  priceEurPerKg: number | null;
  priceEurPerPiece: number | null;
  shelfDays: number | null;
  verified: boolean;
}
